import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "ICONS")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Common", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_6 = { class: "row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list" }
const _hoisted_7 = { class: "col mb-4" }
const _hoisted_8 = { class: "p-3 text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Search", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "搜索", -1)
const _hoisted_11 = { class: "col mb-4" }
const _hoisted_12 = { class: "p-3 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Filter", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "筛选", -1)
const _hoisted_15 = { class: "col mb-4" }
const _hoisted_16 = { class: "p-3 text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Export", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "导出", -1)
const _hoisted_19 = { class: "col mb-4" }
const _hoisted_20 = { class: "p-3 text-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Import", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "导入", -1)
const _hoisted_23 = { class: "col mb-4" }
const _hoisted_24 = { class: "p-3 text-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Upload", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "上传", -1)
const _hoisted_27 = { class: "col mb-4" }
const _hoisted_28 = { class: "p-3 text-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Download", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "下载", -1)
const _hoisted_31 = { class: "col mb-4" }
const _hoisted_32 = { class: "p-3 text-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Add", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "添加", -1)
const _hoisted_35 = { class: "col mb-4" }
const _hoisted_36 = { class: "p-3 text-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Edit", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "编辑", -1)
const _hoisted_39 = { class: "col mb-4" }
const _hoisted_40 = { class: "p-3 text-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "View", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "查看", -1)
const _hoisted_43 = { class: "col mb-4" }
const _hoisted_44 = { class: "p-3 text-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Delete", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "删除", -1)
const _hoisted_47 = { class: "col mb-4" }
const _hoisted_48 = { class: "p-3 text-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Cancel", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "取消", -1)
const _hoisted_51 = { class: "col mb-4" }
const _hoisted_52 = { class: "p-3 text-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Submit", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "提交", -1)
const _hoisted_55 = { class: "col mb-4" }
const _hoisted_56 = { class: "p-3 text-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Reset", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "重置", -1)
const _hoisted_59 = { class: "col mb-4" }
const _hoisted_60 = { class: "p-3 text-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Save", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "保存", -1)
const _hoisted_63 = { class: "col mb-4" }
const _hoisted_64 = { class: "p-3 text-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Link", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "链接", -1)
const _hoisted_67 = { class: "col mb-4" }
const _hoisted_68 = { class: "p-3 text-center" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "info", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "信息", -1)
const _hoisted_71 = { class: "col mb-4" }
const _hoisted_72 = { class: "p-3 text-center" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Warning", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "警告", -1)
const _hoisted_75 = { class: "col mb-4" }
const _hoisted_76 = { class: "p-3 text-center" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Success", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "成功", -1)
const _hoisted_79 = { class: "col mb-4" }
const _hoisted_80 = { class: "p-3 text-center" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Fail", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "失败", -1)
const _hoisted_83 = { class: "col mb-4" }
const _hoisted_84 = { class: "p-3 text-center" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Error", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "错误", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h3", null, "Sales Order", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_89 = { class: "row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list" }
const _hoisted_90 = { class: "col mb-4" }
const _hoisted_91 = { class: "p-3 text-center" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Customer", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "用户", -1)
const _hoisted_94 = { class: "col mb-4" }
const _hoisted_95 = { class: "p-3 text-center" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Phone", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "手机号", -1)
const _hoisted_98 = { class: "col mb-4" }
const _hoisted_99 = { class: "p-3 text-center" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Group", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "用户组", -1)
const _hoisted_102 = { class: "col mb-4" }
const _hoisted_103 = { class: "p-3 text-center" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Date", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "日期", -1)
const _hoisted_106 = { class: "col mb-4" }
const _hoisted_107 = { class: "p-3 text-center" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Priority 1", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "优先级1", -1)
const _hoisted_110 = { class: "col mb-4" }
const _hoisted_111 = { class: "p-3 text-center" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Priority 2", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "优先级2", -1)
const _hoisted_114 = { class: "col mb-4" }
const _hoisted_115 = { class: "p-3 text-center" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Priority 3", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "优先级3", -1)
const _hoisted_118 = { class: "col mb-4" }
const _hoisted_119 = { class: "p-3 text-center" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "GMV Mode", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "交易优先", -1)
const _hoisted_122 = { class: "col mb-4" }
const _hoisted_123 = { class: "p-3 text-center" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Gross Profit Mode", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "毛利优先", -1)
const _hoisted_126 = { class: "col mb-4" }
const _hoisted_127 = { class: "p-3 text-center" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "MB Order Type", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "MB订单类型", -1)
const _hoisted_130 = { class: "col mb-4" }
const _hoisted_131 = { class: "p-3 text-center" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Payment", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "支付", -1)
const _hoisted_134 = { class: "col mb-4" }
const _hoisted_135 = { class: "p-3 text-center" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Shipment", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "物流", -1)
const _hoisted_138 = { class: "col mb-4" }
const _hoisted_139 = { class: "p-3 text-center" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Customer Group", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "客户组", -1)
const _hoisted_142 = { class: "col mb-4" }
const _hoisted_143 = { class: "p-3 text-center" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Inventory", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "库存", -1)
const _hoisted_146 = { class: "col mb-4" }
const _hoisted_147 = { class: "p-3 text-center" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Minimum Inventory Request", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "最低履约库存要求", -1)
const _hoisted_150 = { class: "col mb-4" }
const _hoisted_151 = { class: "p-3 text-center" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Verify Status", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "验证状态", -1)
const _hoisted_154 = { class: "col mb-4" }
const _hoisted_155 = { class: "p-3 text-center" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Whole Order", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "整个订单", -1)
const _hoisted_158 = { class: "col mb-4" }
const _hoisted_159 = { class: "p-3 text-center" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Partial SKU", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "部分产品", -1)
const _hoisted_162 = { class: "col mb-4" }
const _hoisted_163 = { class: "p-3 text-center" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "View Details", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "查看详情", -1)
const _hoisted_166 = { class: "col mb-4" }
const _hoisted_167 = { class: "p-3 text-center" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Service Item", -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "服务项目", -1)
const _hoisted_170 = { class: "col mb-4" }
const _hoisted_171 = { class: "p-3 text-center" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Brand", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "品牌", -1)
const _hoisted_174 = { class: "col mb-4" }
const _hoisted_175 = { class: "p-3 text-center" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Start", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "起点", -1)
const _hoisted_178 = { class: "col mb-4" }
const _hoisted_179 = { class: "p-3 text-center" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "End", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "终点", -1)
const _hoisted_182 = { class: "col mb-4" }
const _hoisted_183 = { class: "p-3 text-center" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Submitted", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "提交订单", -1)
const _hoisted_186 = { class: "col mb-4" }
const _hoisted_187 = { class: "p-3 text-center" }
const _hoisted_188 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Verified", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "订单验证", -1)
const _hoisted_190 = { class: "col mb-4" }
const _hoisted_191 = { class: "p-3 text-center" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Assign", -1)
const _hoisted_193 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "订单指派", -1)
const _hoisted_194 = { class: "col mb-4" }
const _hoisted_195 = { class: "p-3 text-center" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Approved", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "订单确认", -1)
const _hoisted_198 = { class: "col mb-4" }
const _hoisted_199 = { class: "p-3 text-center" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Shipped", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "订单发货", -1)
const _hoisted_202 = { class: "col mb-4" }
const _hoisted_203 = { class: "p-3 text-center" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Order Reviewed", -1)
const _hoisted_205 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "商品检验", -1)
const _hoisted_206 = { class: "col mb-4" }
const _hoisted_207 = { class: "p-3 text-center" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Article Shipped", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "商品发货", -1)
const _hoisted_210 = { class: "col mb-4" }
const _hoisted_211 = { class: "p-3 text-center" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Article Delivered", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "商品签收", -1)
const _hoisted_214 = { class: "col mb-4" }
const _hoisted_215 = { class: "p-3 text-center" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Priority Management", -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "优先级管理", -1)
const _hoisted_218 = { class: "col mb-4" }
const _hoisted_219 = { class: "p-3 text-center" }
const _hoisted_220 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "PIM Addtional Service", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "附加PIM服务", -1)
const _hoisted_222 = { class: "col mb-4" }
const _hoisted_223 = { class: "p-3 text-center" }
const _hoisted_224 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Fulfillment Additional Service", -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "附加履约服务", -1)
const _hoisted_226 = { class: "col mb-4" }
const _hoisted_227 = { class: "p-3 text-center" }
const _hoisted_228 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Settlement Additional Service", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "额外结算服务", -1)
const _hoisted_230 = { class: "col mb-4" }
const _hoisted_231 = { class: "p-3 text-center" }
const _hoisted_232 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "China", -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "中国大陆", -1)
const _hoisted_234 = { class: "col mb-4" }
const _hoisted_235 = { class: "p-3 text-center" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Hong Kong", -1)
const _hoisted_237 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "香港", -1)
const _hoisted_238 = { class: "col mb-4" }
const _hoisted_239 = { class: "p-3 text-center" }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Macao", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "澳门", -1)
const _hoisted_242 = { class: "col mb-4" }
const _hoisted_243 = { class: "p-3 text-center" }
const _hoisted_244 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Europe", -1)
const _hoisted_245 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "欧洲", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _hoisted_9,
          _hoisted_10
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
          ]),
          _hoisted_13,
          _hoisted_14
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
          ]),
          _hoisted_17,
          _hoisted_18
        ]),
        _createElementVNode("li", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr083.svg" })
          ]),
          _hoisted_21,
          _hoisted_22
        ]),
        _createElementVNode("li", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr045.svg" })
          ]),
          _hoisted_25,
          _hoisted_26
        ]),
        _createElementVNode("li", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr044.svg" })
          ]),
          _hoisted_29,
          _hoisted_30
        ]),
        _createElementVNode("li", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
          ]),
          _hoisted_33,
          _hoisted_34
        ]),
        _createElementVNode("li", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
          ]),
          _hoisted_37,
          _hoisted_38
        ]),
        _createElementVNode("li", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen004.svg" })
          ]),
          _hoisted_41,
          _hoisted_42
        ]),
        _createElementVNode("li", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
          ]),
          _hoisted_45,
          _hoisted_46
        ]),
        _createElementVNode("li", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
          ]),
          _hoisted_49,
          _hoisted_50
        ]),
        _createElementVNode("li", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
          ]),
          _hoisted_53,
          _hoisted_54
        ]),
        _createElementVNode("li", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr059.svg" })
          ]),
          _hoisted_57,
          _hoisted_58
        ]),
        _createElementVNode("li", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen064.svg" })
          ]),
          _hoisted_61,
          _hoisted_62
        ]),
        _createElementVNode("li", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com008.svg" })
          ]),
          _hoisted_65,
          _hoisted_66
        ]),
        _createElementVNode("li", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen045.svg" })
          ]),
          _hoisted_69,
          _hoisted_70
        ]),
        _createElementVNode("li", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _hoisted_73,
          _hoisted_74
        ]),
        _createElementVNode("li", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
          ]),
          _hoisted_77,
          _hoisted_78
        ]),
        _createElementVNode("li", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen063.svg" })
          ]),
          _hoisted_81,
          _hoisted_82
        ]),
        _createElementVNode("li", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen040.svg" })
          ]),
          _hoisted_85,
          _hoisted_86
        ])
      ]),
      _hoisted_87,
      _hoisted_88,
      _createElementVNode("ul", _hoisted_89, [
        _createElementVNode("li", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
          ]),
          _hoisted_92,
          _hoisted_93
        ]),
        _createElementVNode("li", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/electronics/elc002.svg" })
          ]),
          _hoisted_96,
          _hoisted_97
        ]),
        _createElementVNode("li", _hoisted_98, [
          _createElementVNode("div", _hoisted_99, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com014.svg" })
          ]),
          _hoisted_100,
          _hoisted_101
        ]),
        _createElementVNode("li", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen013.svg" })
          ]),
          _hoisted_104,
          _hoisted_105
        ]),
        _createElementVNode("li", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr073.svg" })
          ]),
          _hoisted_108,
          _hoisted_109
        ]),
        _createElementVNode("li", _hoisted_110, [
          _createElementVNode("div", _hoisted_111, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr081.svg" })
          ]),
          _hoisted_112,
          _hoisted_113
        ]),
        _createElementVNode("li", _hoisted_114, [
          _createElementVNode("div", _hoisted_115, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr093.svg" })
          ]),
          _hoisted_116,
          _hoisted_117
        ]),
        _createElementVNode("li", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm003.svg" })
          ]),
          _hoisted_120,
          _hoisted_121
        ]),
        _createElementVNode("li", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin004.svg" })
          ]),
          _hoisted_124,
          _hoisted_125
        ]),
        _createElementVNode("li", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm001.svg" })
          ]),
          _hoisted_128,
          _hoisted_129
        ]),
        _createElementVNode("li", _hoisted_130, [
          _createElementVNode("div", _hoisted_131, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin008.svg" })
          ]),
          _hoisted_132,
          _hoisted_133
        ]),
        _createElementVNode("li", _hoisted_134, [
          _createElementVNode("div", _hoisted_135, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm006.svg" })
          ]),
          _hoisted_136,
          _hoisted_137
        ]),
        _createElementVNode("li", _hoisted_138, [
          _createElementVNode("div", _hoisted_139, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com014.svg" })
          ]),
          _hoisted_140,
          _hoisted_141
        ]),
        _createElementVNode("li", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm008.svg" })
          ]),
          _hoisted_144,
          _hoisted_145
        ]),
        _createElementVNode("li", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm011.svg" })
          ]),
          _hoisted_148,
          _hoisted_149
        ]),
        _createElementVNode("li", _hoisted_150, [
          _createElementVNode("div", _hoisted_151, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen048.svg" })
          ]),
          _hoisted_152,
          _hoisted_153
        ]),
        _createElementVNode("li", _hoisted_154, [
          _createElementVNode("div", _hoisted_155, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen005.svg" })
          ]),
          _hoisted_156,
          _hoisted_157
        ]),
        _createElementVNode("li", _hoisted_158, [
          _createElementVNode("div", _hoisted_159, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra007.svg" })
          ]),
          _hoisted_160,
          _hoisted_161
        ]),
        _createElementVNode("li", _hoisted_162, [
          _createElementVNode("div", _hoisted_163, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
          ]),
          _hoisted_164,
          _hoisted_165
        ]),
        _createElementVNode("li", _hoisted_166, [
          _createElementVNode("div", _hoisted_167, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen057.svg" })
          ]),
          _hoisted_168,
          _hoisted_169
        ]),
        _createElementVNode("li", _hoisted_170, [
          _createElementVNode("div", _hoisted_171, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen056.svg" })
          ]),
          _hoisted_172,
          _hoisted_173
        ]),
        _createElementVNode("li", _hoisted_174, [
          _createElementVNode("div", _hoisted_175, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen015.svg" })
          ]),
          _hoisted_176,
          _hoisted_177
        ]),
        _createElementVNode("li", _hoisted_178, [
          _createElementVNode("div", _hoisted_179, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
          ]),
          _hoisted_180,
          _hoisted_181
        ]),
        _createElementVNode("li", _hoisted_182, [
          _createElementVNode("div", _hoisted_183, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen005.svg" })
          ]),
          _hoisted_184,
          _hoisted_185
        ]),
        _createElementVNode("li", _hoisted_186, [
          _createElementVNode("div", _hoisted_187, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/files/fil025.svg" })
          ]),
          _hoisted_188,
          _hoisted_189
        ]),
        _createElementVNode("li", _hoisted_190, [
          _createElementVNode("div", _hoisted_191, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm004.svg" })
          ]),
          _hoisted_192,
          _hoisted_193
        ]),
        _createElementVNode("li", _hoisted_194, [
          _createElementVNode("div", _hoisted_195, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm009.svg" })
          ]),
          _hoisted_196,
          _hoisted_197
        ]),
        _createElementVNode("li", _hoisted_198, [
          _createElementVNode("div", _hoisted_199, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm006.svg" })
          ]),
          _hoisted_200,
          _hoisted_201
        ]),
        _createElementVNode("li", _hoisted_202, [
          _createElementVNode("div", _hoisted_203, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
          ]),
          _hoisted_204,
          _hoisted_205
        ]),
        _createElementVNode("li", _hoisted_206, [
          _createElementVNode("div", _hoisted_207, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/maps/map010.svg" })
          ]),
          _hoisted_208,
          _hoisted_209
        ]),
        _createElementVNode("li", _hoisted_210, [
          _createElementVNode("div", _hoisted_211, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen017.svg" })
          ]),
          _hoisted_212,
          _hoisted_213
        ]),
        _createElementVNode("li", _hoisted_214, [
          _createElementVNode("div", _hoisted_215, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs020.svg" })
          ]),
          _hoisted_216,
          _hoisted_217
        ]),
        _createElementVNode("li", _hoisted_218, [
          _createElementVNode("div", _hoisted_219, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs026.svg" })
          ]),
          _hoisted_220,
          _hoisted_221
        ]),
        _createElementVNode("li", _hoisted_222, [
          _createElementVNode("div", _hoisted_223, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs036.svg" })
          ]),
          _hoisted_224,
          _hoisted_225
        ]),
        _createElementVNode("li", _hoisted_226, [
          _createElementVNode("div", _hoisted_227, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs006.svg" })
          ]),
          _hoisted_228,
          _hoisted_229
        ]),
        _createElementVNode("li", _hoisted_230, [
          _createElementVNode("div", _hoisted_231, [
            _createVNode(_component_inline_svg, { src: "media/icons/flat/icon-china.svg" })
          ]),
          _hoisted_232,
          _hoisted_233
        ]),
        _createElementVNode("li", _hoisted_234, [
          _createElementVNode("div", _hoisted_235, [
            _createVNode(_component_inline_svg, { src: "media/icons/flat/icon-hk.svg" })
          ]),
          _hoisted_236,
          _hoisted_237
        ]),
        _createElementVNode("li", _hoisted_238, [
          _createElementVNode("div", _hoisted_239, [
            _createVNode(_component_inline_svg, { src: "media/icons/flat/icon-macao.svg" })
          ]),
          _hoisted_240,
          _hoisted_241
        ]),
        _createElementVNode("li", _hoisted_242, [
          _createElementVNode("div", _hoisted_243, [
            _createVNode(_component_inline_svg, { src: "media/icons/flat/icon-eu.svg" })
          ]),
          _hoisted_244,
          _hoisted_245
        ])
      ])
    ])
  ]))
}